class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
        input: '.d_range-slider__input',
        inputMin: '.d_range-slider__input--min',
        inputMax: '.d_range-slider__input--max',
        rangeSlider: '.d_range-slider__range',
        strValueMin: '#values-min',
        strValueMax: '#values-max'
    }
    this.sliderGap = 10;
  }

  connectedCallback() {
    
    this.minStrValue = this.querySelector(this.selectors.strValueMin);
    this.maxStrValue = this.querySelector(this.selectors.strValueMax);

    this.dataMin = this.querySelector(this.selectors.inputMin);
    this.dataMax = this.querySelector(this.selectors.inputMax);

    this.rangeTrack = this.querySelector(this.selectors.rangeSlider);

    // bind once so we can remove later
    this.onRangeChange = this.onRangeChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.updateTracks = this.updateTracks.bind(this);
    this.lockMinMaxValues = this.lockMinMaxValues.bind(this);

    this.querySelectorAll(this.selectors.input).forEach((el) => {
      el.addEventListener("input", this.onRangeChange); // fires while dragging
      el.addEventListener("keydown", this.onKeyDown);
      // el.addEventListener('change', this.onRangeChange); // optional, on release
    });

    this.updateTracks();
  }

  disconnectedCallback() {
    this.querySelectorAll(this.selectors.rangeSlider).forEach((el) => {
      el.removeEventListener("input", this.onRangeChange);
      el.removeEventListener("keydown", this.onKeyDown);
    });
  }

  onRangeChange(e) {
    this.lockMinMaxValues(e);
    this.updateTracks();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  lockMinMaxValues(e) {
    let minVal = parseFloat(this.dataMin.value);
    let maxVal = parseFloat(this.dataMax.value);

    if (e.target === this.dataMin) {
      // dragging the min
      if (minVal > maxVal - this.sliderGap) {
        this.dataMin.value = maxVal - this.sliderGap;
        minVal = maxVal - this.sliderGap;
      }
    }

    if (e.target === this.dataMax) {
      // dragging the max
      if (maxVal < minVal + this.sliderGap) {
        this.dataMax.value = minVal + this.sliderGap;
        maxVal = minVal + this.sliderGap;
      }
    }
  }

  updateTracks() {
    const min = parseFloat(this.dataMin.min);
    const max = parseFloat(this.dataMax.max);
    const minVal = parseFloat(this.dataMin.value);
    const maxVal = parseFloat(this.dataMax.value);

    const percentMin = ((minVal - min) / (max - min)) * 100;
    const percentMax = ((maxVal - min) / (max - min)) * 100;

    if (this.rangeTrack) {
      this.rangeTrack.style.left = percentMin + "%";
      this.rangeTrack.style.width = percentMax - percentMin + "%";
    }

    this.minStrValue.innerHTML = this.convertNumberToMoney(this.nextInt(minVal));
    this.maxStrValue.innerHTML = this.convertNumberToMoney(this.nextInt(maxVal));
  }

  convertNumberToMoney(value, currency = "EUR") {
    return new Intl.NumberFormat("pt-PT", {
      style: "currency",
      currency,
    }).format(value);
  }

  nextInt(num) {
    if (num < 1) return 0;
    return Math.ceil(num);
  }
}

customElements.define("s-price-range", PriceRange);
